import Perfil from "../../components/common/perfil";

function ShoppingPerfil() {

    return (
        <div>
            <Perfil />
        </div>
    )
}

export default ShoppingPerfil;